var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "leftCardContainer" },
    [
      _c(
        "div",
        { staticClass: "rightSideTitleActions" },
        [
          _c("tasks-management-tabs", {
            attrs: { activeTab: _vm.activeTab, tabs: _vm.tabs },
            on: { startTabChange: _vm.handleTabChange }
          }),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "actionsContainer" },
            [
              _c(
                "div",
                { staticClass: "searchContainer" },
                [
                  _c("v-icon", [_vm._v(" search ")]),
                  _vm._v(" "),
                  _c("InputField", {
                    attrs: {
                      inputType: "text",
                      value: _vm.search,
                      placeholder: _vm.$t("Search"),
                      inputStyle: {
                        borderRadius: "0px",
                        width: "130px",
                        borderTop: "none",
                        borderRight: "none",
                        borderLeft: "none",
                        borderBottom: "none"
                      },
                      inputFieldContainerStyling: {
                        padding: "0px 20px"
                      }
                    },
                    on: {
                      input: function($event) {
                        return _vm.handleSearch($event)
                      }
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c("CustomButton", {
                attrs: {
                  icon: "download ",
                  width: "20px",
                  height: "20px",
                  iconSize: 12,
                  disabled: !_vm.selectedObjectUuid,
                  buttonStyling: {
                    padding: "8px",
                    marginRight: "5px",
                    borderRadius: "4px"
                  }
                },
                on: { buttonClick: _vm.downloadObjects }
              }),
              _vm._v(" "),
              _c("CustomButton", {
                attrs: {
                  icon: "print",
                  width: "20px",
                  height: "20px",
                  iconSize: 12,
                  buttonStyling: {
                    padding: "8px",
                    marginRight: "5px",
                    borderRadius: "4px"
                  },
                  disabled: true
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      !_vm.activeTabIsTask
        ? _c("filter-buttons", {
            attrs: { filters: _vm.filters, activeFilter: _vm.activeFilter },
            on: { "select-filter": _vm.handleFilterSelect }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.activeTab > 1
        ? _c("div", { staticClass: "titleContainer" }, [
            _c("span", { staticClass: "leftTitle" }, [
              _vm._v(_vm._s(_vm.tableTitle))
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "tableDivContainer",
          style: { height: _vm.activeTabIsTask ? "90%" : "80%" }
        },
        [
          _c("Table", {
            attrs: {
              checkbox: false,
              loading: _vm.loading,
              headers: _vm.headers,
              items: _vm.objects,
              sortable: true,
              "scroll-id": _vm.mainTableScrollId,
              emitRowClickBusEvent: !_vm.activeTabIsTask
            },
            on: {
              onScrollBottom: _vm.onScrollBottom,
              onScrollTop: _vm.onScrollTop,
              sortClick: _vm.onSortClick,
              onRowClick: _vm.updateTaskStepData
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c("loading-spinner", {
        staticStyle: { position: "absolute" },
        attrs: {
          active: _vm.loading,
          "is-full-page": false,
          color: "var(--app-primary-base)"
        },
        on: {
          "update:active": function($event) {
            _vm.loading = $event
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-57631f73", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-57631f73","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/newComponents/TasksManagement/TableView.vue
// module id = null
// module chunks = 